export enum CookieBannerType {
  RBI_COOKIE_BANNER = 'customCookieBanner',
  EXTERNAL_COOKIE_BANNER = 'externalCookieBanner',
  COOKIEBOT_COOKIE_BANNER = 'cookieBotCookieBanner',
  ONE_TRUST_COOKIE_BANNER = 'oneTrust',
}
